module.exports = __webpack_public_path__ + "img/chaudiere.722772ae.svg";